import {
  groupedManagerFilterFormatter,
  managerFilterFormatter,
} from './managerFilterFormatter';

export const filterFormatters = {
  conversionAgent: groupedManagerFilterFormatter,
  closerManager: groupedManagerFilterFormatter,
  retentionManager: groupedManagerFilterFormatter,
  vipManager: groupedManagerFilterFormatter,
  firstContactManager: managerFilterFormatter,
  conversionAgentCreated: groupedManagerFilterFormatter,
  closerManagerCreated: groupedManagerFilterFormatter,
  retentionManagerCreated: groupedManagerFilterFormatter,
  vipManagerCreated: groupedManagerFilterFormatter,
};

export { managerOptionsSorting } from './optionsMappers';
export { ManagersSelect, ManagerSelectProps } from './ManagersSelect';
export { ManagerDictionariesType } from './types';
